import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import ContentLayout from '@/layouts/content-layout'
import ProductFormView from '@/sections/products/view/product-form-view'

export default function ProductFormPage() {
  const location = useLocation()

  // Determine title based on pathname
  const title = useMemo(() => {
    if (location.pathname.includes('/products/create')) {
      return 'เพิ่มสินค้า'
    }
    if (location.pathname.match(/^\/products\/[^/]+\/edit/)) {
      return 'แก้ไขสินค้า'
    }
    return 'สินค้า'
  }, [location.pathname])

  return (
    <ContentLayout title={title} backButton>
      <ProductFormView />
    </ContentLayout>
  )
}
